
import gql from 'graphql-tag';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import termLifePlanScenariosQuery from '~/apollo/queries/product/termLifePlanScenarios';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import currenciesQuery from '~/apollo/queries/product/currencies';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import termLifeBenchmark from '~/apollo/queries/product/termLifeBenchmark';
import termLifeTooltips from '~/apollo/queries/product/tooltips/termlifeTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import insuranceGuideQuery from '@/apollo/queries/home/insuranceguide'
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'ProductsTermLifeListingPage',
  mixins: [commonProductMixins, productPromotionMixins, productShortcutMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    termLifePlanScenarios: {
      query: gql`
        ${termLifePlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        let tmpComp;
        tmpComp = undefined;

        let tmpUnderwriting;
        tmpUnderwriting = undefined;

        let tmpRenewalTerm;
        tmpRenewalTerm = undefined;

        let tmpLocale;
        tmpLocale = undefined;

        let tmpBrokerInd;
        tmpBrokerInd = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
        }

        if (parseInt(this.filter.underwritingValue?.value) !== -1) {
          // as different locale has different underwritingValue
          // so using .text here for this special case
          tmpUnderwriting = this.filter.underwritingValue?.text;
        }

        if (parseInt(this.filter.renewalTermValue?.value) !== -1) {
          tmpRenewalTerm = parseInt(this.filter.renewalTermValue?.value);
        }

        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        if (this.filter.advisorAssistanceValue) {
          tmpBrokerInd = this.filter.advisorAssistanceValue;
        }

        // tmpComp = [129,130,131];
        return {
          insCompCode: tmpComp,
          gender: parseInt(this.filter.genderValue?.value),
          age: parseInt(this.filter.ageValue?.value),
          renewal_term: tmpRenewalTerm,
          locale: tmpLocale,
          underwriting_text: tmpUnderwriting,
          sum_assured: parseFloat(this.filter.totalPremiumValue?.value),
          broker_ind: tmpBrokerInd,
        };
      },
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() {
        return {
          show_termlife: true,
        };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      },
    },

    currencies: {
      query: currenciesQuery,
      prefetch: true,
    },

    termLifeBenchmarks: {
      query: termLifeBenchmark,
      prefetch: true,
      variables() {
        return {
          gender: parseInt(this.filter.genderValue?.value),
          age: parseInt(this.filter.ageValue?.value),
          sum_assured: parseFloat(this.filter.totalPremiumValue?.value),
        };
      },
    },

    termLifeTooltips: {
      query: termLifeTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  data() {
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
      filter: {
        insCompValue: [],

        genderValue: {
          value: this.$route.query.gender ? this.$route.query.gender : '1',
          text: this.$t('products.male'),
        },
        genderOptions: [
          { value: '1', text: this.$t('products.male') },
          { value: '2', text: this.$t('products.female') },
        ],

        ageValue: { value: this.$route.query.age ? this.$route.query.age : '35', text: '35' },
        ageOptions: [
          { value: '25', text: '25' },
          { value: '35', text: '35' },
          { value: '45', text: '45' },
        ],

        renewalTermValue: { value: this.$route.query.renewal_term ? this.$route.query.renewal_term : '-1', text: '' },
        renewalTermOptions: [
          { value: '-1', text: this.$t('products.any') },
          { value: '1', text: this.getRenewal(this.$t('products.termLife.tl_renewalUnit'), 1) },
          { value: '5', text: this.getRenewal(this.$t('products.termLife.tl_renewalUnit'), 5) },
          { value: '10', text: this.getRenewal(this.$t('products.termLife.tl_renewalUnit'), 10) },
          { value: '20', text: this.getRenewal(this.$t('products.termLife.tl_renewalUnit'), 20) },
        ],

        targetPeriodValue: {
          value: this.$route.query.target_period ? this.$route.query.target_period : '10',
          text: '10 ' + this.$t('products.yearsUnit'),
        },
        targetPeriodOptions: [
          { value: '10', text: '10 ' + this.$t('products.yearsUnit') },
          { value: '20', text: '20 ' + this.$t('products.yearsUnit') },
        ],

        totalPremiumValue: {
          value: this.$route.query.total_premium ? this.$route.query.total_premium : '1000000',
          text: '1,000,000',
        },
        totalPremiumOptions: [
          { value: '1000000', text: '1,000,000' },
          { value: '2000000', text: '2,000,000' },
          { value: '3000000', text: '3,000,000' },
          { value: '4000000', text: '4,000,000' },
          { value: '5000000', text: '5,000,000' },
          { value: '6000000', text: '6,000,000' },
          { value: '7000000', text: '7,000,000' },
          { value: '8000000', text: '8,000,000' },
          { value: '9000000', text: '9,000,000' },
          { value: '10000000', text: '10,000,000' },
        ],

        underwritingValue: { value: this.$route.query.underwriting ? this.$route.query.underwriting : '-1', text: '' },
        underwritingOptions: [
          { value: '-1', text: this.$t('products.any') },
          { value: '2', text: this.$t('products.standardUnderwriting') },
          { value: '3', text: this.$t('products.onlineUnderwriting') },
        ],

        advisorAssistanceValue: this.$route.query.advisorAssistance === 'true',
      },
      perPage: 15,
      currentPage: 1,
      termLifePlanScenarios: null,
      insuranceCompanies: [],

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'score', text: '' },
        sortingOptions: [
          { value: 'score', text: this.$t('products.termLife.tl_10LifeRating') },
          {
            value: 'avg_premium',
            text:
              (this.$route.query.target_period ? this.$route.query.target_period : '10') +
              this.$t('products.termLife.tl_YearAveragePremium'),
          },
          { value: 'first_premium', text: this.$t('products.termLife.tl_firstYearPremium') },
        ],
      },
    };
  },

  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
    },
    mainQueryLoading() {
      return this.$apollo.queries.termLifePlanScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.termLife.tl_result').replace('$num', '{ }');
      } else {
        return this.$t('products.termLife.tl_result').replace('$num', this.rows);
      }
    },

    displayProducts() {
      return this.sortedItem?.map((item) => ({
        scenarioId: item.scenarioID,
        id: item.scenario_code,
        category: this.category,
        showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
        showTrending: false,
        productLink: this.$extendPath(
          this.$route.path,
          '/' +
            item.scenario_code +
            '?age=' +
            this.filter.ageValue?.value +
            '&targetPeriod=' +
            this.filter.targetPeriodValue?.value +
            '&gender=' +
            this.filter.genderValue?.value +
            '&sum_assured=' +
            this.filter.totalPremiumValue?.value
        ),
        productName: item.plan_name,
        insuranceCompany: {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo?.data?.attributes.url,
          logoAlt: item.insurer_name_first,
        },
        userRating: {
          score: item.overall_star,
          numberOfRatedUser: '0',
        },
        tenlifeScore: {
          score: parseFloat(this.getScore(this.filter, item)),
          description: this.$t('products.termLife.tl_10LifeRating'),
          toolTipHtml: this.getTooltipContentByKey('tl_termLifeScore'),
        },
        features: [
          {
            text: item.underwriting_text,
            type: 'underwriting',
          },
        ],
        keyItems: [
          {
            value:
              '<span style="white-space: nowrap;">' +
              item.coverage_score.toFixed(1).toString() +
              ' / <small>10</small> </span>',
            key: this.$t('products.termLife.tl_termsScore'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.getRenewal(this.$t('products.renewalUnit'), item.renewal_term),
            key: this.$t('products.renewalTerm'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.sortingData.sortValue.value !== 'avg_premium' ?
            item.discounted_ten_year_avg_premium
              ? this.filter.targetPeriodValue?.value === '10'
                ? item.discounted_ten_year_avg_premium
                : item.discounted_twenty_year_avg_premium
              : this.getAvgPremium(this.filter, item)
            :
            item.promotion_prices[0]
              ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
                : parseInt(
                item.first_year_premium
                ).toLocaleString('en-US'),
            key: this.sortingData.sortValue.value !== 'avg_premium' ?
              this.filter.targetPeriodValue?.value + this.$t('products.termLife.tl_YearAveragePremium')
              :
              this.$t('products.termLife.tl_firstYearPremium'),
            topSubText: 'HKD',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: this.sortingData.sortValue.value !== 'avg_premium' ?
            item.discounted_ten_year_avg_premium ? this.getAvgPremium(this.filter, item) : ''
            :
            item.promotion_prices[0] ? parseInt(item.first_year_premium).toLocaleString('en-US') : '',
          },
        ],
        mobileKeyItems: [
          {
            value:
              '<span style="white-space: nowrap;">' +
              item.coverage_score.toFixed(1).toString() +
              ' / <small>10</small> </span>',
            key: this.$t('products.termLife.tl_termsScore'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
          {
            value: this.getRenewal(this.$t('products.renewalUnit'), item.renewal_term),
            key: this.$t('products.renewalTerm'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
          {
            value: this.sortingData.sortValue.value !== 'avg_premium' ?
            item.discounted_ten_year_avg_premium
              ? this.filter.targetPeriodValue?.value === '10'
                ? item.discounted_ten_year_avg_premium
                : item.discounted_twenty_year_avg_premium
              : this.getAvgPremium(this.filter, item)
            :
            item.promotion_prices[0]
              ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
                : parseInt(
                item.first_year_premium
                ).toLocaleString('en-US'),
            key: this.sortingData.sortValue.value !== 'avg_premium' ?
              this.filter.targetPeriodValue?.value + this.$t('products.termLife.tl_YearAveragePremium')
              :
              this.$t('products.termLife.tl_firstYearPremium'),
            topSubText: 'HKD',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: this.sortingData.sortValue.value !== 'avg_premium' ?
            item.discounted_ten_year_avg_premium ? this.getAvgPremium(this.filter, item) : ''
            :
            item.promotion_prices[0] ? parseInt(item.first_year_premium).toLocaleString('en-US') : '',
            isTextBold: true,
          },
        ],
        compactKeyItems: [
          // {
          //   value: item.promotion_prices[0]
          //     ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
          //     : parseInt(
          //         item.first_year_premium
          //       ).toLocaleString('en-US'),
          //   key: this.$t('products.termLife.tl_firstYearPremium'),
          //   topSubText: 'HKD',
          //   toolTipHtml: '',
          //   symbolValue: '',
          //   originalValue: item.promotion_prices[0]
          //     ? parseInt(
          //       item.first_year_premium
          //       ).toLocaleString('en-US')
          //     : '',
          //     isTextBold: true,
          //   // if isDiscount ? discountPrice : OriginalPrice
          // },
          {
            value: item.coverage_score.toFixed(1).toString() + ' / <small>10</small>',
            key: this.$t('products.termLife.tl_termsScore'),
            topSubText: '',
            toolTipHtml: '',
            symbolValue: '',
            originalValue: '',
            isTextBlack: true
          },
        ],
        promotion: {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          lastCall: item.promotion_last_call

        },
        mainButtonCTA: {
          text: item.decoder_cta_text,
          link: item.decoder_cta_link,
        },
        showShortcut: item.shortcut,
        price: {
          originalPrice: this.sortingData.sortValue.value == 'avg_premium' ?
            item.discounted_ten_year_avg_premium ? this.getAvgPremium(this.filter, item) : ''
            :
            item.promotion_prices[0] ? parseInt(item.first_year_premium).toLocaleString('en-US') : '',
          discountPrice: this.sortingData.sortValue.value == 'avg_premium' ?
            item.discounted_ten_year_avg_premium
              ? this.filter.targetPeriodValue?.value === '10'
                ? item.discounted_ten_year_avg_premium
                : item.discounted_twenty_year_avg_premium
              : this.getAvgPremium(this.filter, item)
            :
            item.promotion_prices[0]
              ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
                : parseInt(
                item.first_year_premium
                ).toLocaleString('en-US'),
          prefix: 'HKD',
          postfix: '',
          subText: this.sortingData.sortValue.value == 'avg_premium' ?
              this.filter.targetPeriodValue?.value + this.$t('products.termLife.tl_YearAveragePremium')
              :
              this.$t('products.termLife.tl_firstYearPremium'),
          toolTipHtml: '',
        },
      }));
    },

    rows() {
      const items = this.simpleItems;
      if (items) {
        return items.length;
      }
      return null;
    },

    // underwritingOptions() {
    //  return [
    //         {"value":"-1","text":"Any"},
    //         {"value": this.$t('products.standardUnderwriting'),"text": this.$t('products.standardUnderwriting')},
    //         {"value": this.$t('products.onlineUnderwriting') ,"text": this.$t('products.onlineUnderwriting')}
    //       ];
    // },

    sortedItem() {
      const items = this.simpleItems;
      if (this.sortingData.sortValue.value === 'score') {
        if (items) {
          if (this.filter.targetPeriodValue?.value === '10') {
            return items
              .map((item) => item)
              .sort((a, b) => {
                let aAvgPrem = a.ten_year_avg_premium;
                let bAvgPrem = b.ten_year_avg_premium;
                if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
                if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

                let aFirstPrem = a.first_year_premium;
                let bFirstPrem = b.first_year_premium;
                if (a.promotion_prices[0]) {
                  aFirstPrem = a.promotion_prices[0] / 1000;
                }
                if (b.promotion_prices[0]) {
                  bFirstPrem = b.promotion_prices[0] / 1000;
                }

                return b.ten_year_rating - a.ten_year_rating || aAvgPrem - bAvgPrem || aFirstPrem - bFirstPrem;
              });
          } else {
            return items
              .map((item) => item)
              .sort((a, b) => {
                let aAvgPrem = a.twenty_year_avg_premium;
                let bAvgPrem = b.twenty_year_avg_premium;
                if (a.discounted_twenty_year_avg_premium) aAvgPrem = a.discounted_twenty_year_avg_premium;
                if (b.discounted_twenty_year_avg_premium) bAvgPrem = b.discounted_twenty_year_avg_premium;

                let aFirstPrem = a.first_year_premium;
                let bFirstPrem = b.first_year_premium;
                if (a.promotion_prices[0]) {
                  aFirstPrem = a.promotion_prices[0] / 1000;
                }
                if (b.promotion_prices[0]) {
                  bFirstPrem = b.promotion_prices[0] / 1000;
                }

                return b.twenty_year_rating - a.twenty_year_rating || aAvgPrem - bAvgPrem || aFirstPrem - bFirstPrem;
              });
          }
        }
      }
      // else if (this.sortingData.sortValue.value === "terms_score"){
      //   if (items) {
      //     return items.map(item=>item).sort((a,b)=>
      //       {

      //         let aAvgPrem = a.ten_year_avg_premium;
      //         let bAvgPrem = b.ten_year_avg_premium;
      //         if(a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
      //         if(b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

      //         let aFirstPrem = a.first_year_premium.data.attributes["age_"+ this.filter.ageValue?.value];
      //         let bFirstPrem = b.first_year_premium.data.attributes["age_"+ this.filter.ageValue?.value];
      //         if(a.promotion_prices[0]) { aFirstPrem = a.promotion_prices[0]/1000;}
      //         if(b.promotion_prices[0]) { bFirstPrem = b.promotion_prices[0]/1000;}
      //         return b.coverage_score - a.coverage_score;
      //       }
      //     )
      //   }
      // }
      // else if (this.sortingData.sortValue.value === "renewal_term"){
      //   if (items) {
      //     return items.map(item=>item).sort((a,b)=>
      //       b.renewal_term - a.renewal_term
      //     )
      //   }
      // }
      else if (this.sortingData.sortValue.value === 'avg_premium') {
        if (items) {
          if (this.filter.targetPeriodValue?.value === '10') {
            return items
              .map((item) => item)
              .sort((a, b) => {
                let aAvgPrem = a.ten_year_avg_premium;
                let bAvgPrem = b.ten_year_avg_premium;
                if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
                if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

                let aFirstPrem = a.first_year_premium;
                let bFirstPrem = b.first_year_premium;
                if (a.promotion_prices[0]) {
                  aFirstPrem = a.promotion_prices[0] / 1000;
                }
                if (b.promotion_prices[0]) {
                  bFirstPrem = b.promotion_prices[0] / 1000;
                }

                return aAvgPrem - bAvgPrem || b.ten_year_rating - a.ten_year_rating || aFirstPrem - bFirstPrem;
              });
          } else {
            return items
              .map((item) => item)
              .sort((a, b) =>
                // a.discounted_twenty_year_avg_premium - b.discounted_twenty_year_avg_premium
                {
                  let aAvgPrem = a.twenty_year_avg_premium;
                  let bAvgPrem = b.twenty_year_avg_premium;
                  if (a.discounted_twenty_year_avg_premium) aAvgPrem = a.discounted_twenty_year_avg_premium;
                  if (b.discounted_twenty_year_avg_premium) bAvgPrem = b.discounted_twenty_year_avg_premium;

                  let aFirstPrem = a.first_year_premium;
                  let bFirstPrem = b.first_year_premium
                  if (a.promotion_prices[0]) {
                    aFirstPrem = a.promotion_prices[0] / 1000;
                  }
                  if (b.promotion_prices[0]) {
                    bFirstPrem = b.promotion_prices[0] / 1000;
                  }

                  return aAvgPrem - bAvgPrem || b.ten_year_rating - a.ten_year_rating || aFirstPrem - bFirstPrem;
                }
              );
          }
        }
      } else if (this.sortingData.sortValue.value === 'first_premium') {
        if (items) {
          if (this.filter.targetPeriodValue?.value === '10') {
            return items
              .map((item) => item)
              .sort((a, b) =>
                // a.first_year_premium.data.attributes["age_"+ this.filter.ageValue?.value] - b.first_year_premium.data.attributes["age_"+ this.filter.ageValue?.value]
                {
                  let aAvgPrem = a.ten_year_avg_premium;
                  let bAvgPrem = b.ten_year_avg_premium;
                  if (a.discounted_ten_year_avg_premium) aAvgPrem = a.discounted_ten_year_avg_premium;
                  if (b.discounted_ten_year_avg_premium) bAvgPrem = b.discounted_ten_year_avg_premium;

                  let aFirstPrem = a.first_year_premium;
                  let bFirstPrem = b.first_year_premium;
                  if (a.promotion_prices[0]) {
                    aFirstPrem = a.promotion_prices[0] / 1000;
                  }
                  if (b.promotion_prices[0]) {
                    bFirstPrem = b.promotion_prices[0] / 1000;
                  }
                  return aFirstPrem - bFirstPrem || b.ten_year_rating - a.ten_year_rating || aAvgPrem - bAvgPrem;
                }
              );
          } else {
            return items
              .map((item) => item)
              .sort((a, b) => {
                let aAvgPrem = a.twenty_year_avg_premium;
                let bAvgPrem = b.twenty_year_avg_premium;
                if (a.discounted_twenty_year_avg_premium) aAvgPrem = a.discounted_twenty_year_avg_premium;
                if (b.discounted_twenty_year_avg_premium) bAvgPrem = b.discounted_twenty_year_avg_premium;

                let aFirstPrem = a.first_year_premium;
                let bFirstPrem = b.first_year_premium;
                if (a.promotion_prices[0]) {
                  aFirstPrem = a.promotion_prices[0] / 1000;
                }
                if (b.promotion_prices[0]) {
                  bFirstPrem = b.promotion_prices[0] / 1000;
                }
                return aFirstPrem - bFirstPrem || b.twenty_year_rating - a.twenty_year_rating || aAvgPrem - bAvgPrem;
              });
          }
        }
      }

      return null;
    },
    simpleItems() {
      if (this.termLifePlanScenarios && this.termLifeBenchmarks) {
        return this.termLifePlanScenarios?.data?.map((item) => {
          let promotionPrices = Array;
          promotionPrices = [];

          let tenYearConstant = 0;
          let twentyYearConstant = 0;
          // get termlife rating calculation constant
          // if (this.termLifeBenchmarks.data.length > 0) {
          //  tenYearConstant = this.termLifeBenchmarks.data[0].attributes.TenYearConstant;
          //  twentyYearConstant = this.termLifeBenchmarks.data[0].attributes.TwentyYearConstant;
          // }
          this.termLifeBenchmarks.data.forEach((item) => {
            if(item.attributes.Year === 10)
              tenYearConstant = item.attributes.BenchmarkValue;
            if(item.attributes.Year === 20)
              twentyYearConstant = item.attributes.BenchmarkValue;
          });

          // console.log("10YearConstant: "+ tenYearConstant);
          // console.log("20YearConstant: "+ twentyYearConstant);

          let discountedTenYearAvgPremium = null;
          let discountedTwentyYearAvgPremium = null;
          let tenYearRating = item.attributes.ten_year_rating!==null?item.attributes.ten_year_rating:0;
          let twentyYearRating = item.attributes.twenty_year_rating!==null?item.attributes.twenty_year_rating:0;
          let promotions = null;
          let promotion = null;
          let promotion_last_call = null;

          const planName =
            item.attributes.term_life_plan.data.attributes.term_life_plan_translations.data[0].attributes.name;
            const insurer = item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
          let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.termLife.tl_categoryName'), insurer, planName);
          let decoderCTAText = '';

          const premium = item.attributes.term_life_plan_premium;
          const age = parseInt(this.filter.ageValue?.value);
          const renewalTerm = item.attributes.renewal_term;
          const sumAssured = item.attributes.sum_assured;
          const originalPrices = this.getPremium(premium, age, renewalTerm, sumAssured);
          const fyp = parseFloat(originalPrices[0]).toFixed(0);

          const shortcut = this.getProductShortcut(item.attributes);

          // check scenario level promo first , then plan level promotion
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.term_life_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.term_life_plan.data.attributes.product_promotions.data;
          }

          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            promotion_last_call = this.checkPromotionLastCall(promotion);

            if (!promotion) {
              promotion = null;
            } else {
              if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink =
                  promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                decoderCTAText = this.$t('products.product_website');
              }
              const discounts = promotion.attributes.DiscountPercentage;
              if (discounts) {
                // calculate promotion price and avg premium

                const calulatedValue = this.calculateDiscountedPremium(originalPrices, discounts);
                promotionPrices = calulatedValue.promotionPrices;
                discountedTenYearAvgPremium = calulatedValue.discountedTenYearAvgPremium;
                discountedTwentyYearAvgPremium = calulatedValue.discountedTwentyYearAvgPremium;

                const ratings = this.calculateTermlifeScore(
                  tenYearConstant,
                  twentyYearConstant,
                  discountedTenYearAvgPremium,
                  discountedTwentyYearAvgPremium,
                  sumAssured,
                  item.attributes.coverage_score
                );

                if (ratings) {
                  tenYearRating = ratings.tenYearRating;
                  twentyYearRating = ratings.twentyYearRating;
                }

                if (discountedTenYearAvgPremium === item.attributes.ten_year_avg_premium) {
                  discountedTenYearAvgPremium = null;
                }

                if (discountedTwentyYearAvgPremium === item.attributes.twenty_year_avg_premium) {
                  discountedTwentyYearAvgPremium = null;
                }
              }
            }
          }

          const filteredTranslations = this.getFilteredTranslations(item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            scenario_code: item.attributes.scenario_code,
            sum_assured: item.attributes.sum_assured,
            // ten_year_rating: item.attributes.ten_year_rating,
            // twenty_year_rating: item.attributes.twenty_year_rating,
            ten_year_rating: tenYearRating.toFixed(1),
            twenty_year_rating: twentyYearRating.toFixed(1),
            ten_year_avg_premium: item.attributes.ten_year_avg_premium,
            twenty_year_avg_premium: item.attributes.twenty_year_avg_premium,
            coverage_score: item.attributes.coverage_score?item.attributes.coverage_score:0,
            renewal_term: item.attributes.renewal_term,
            underwriting: item.attributes.underwriting,
            overall_star: item.attributes.overall_star,
            // plan
            plan_code: item.attributes.term_life_plan.data.attributes.plan_code,
            issue_age_from: item.attributes.term_life_plan.data.attributes.issue_age_from,

            plan_name: planName,
            underwriting_text:
              item.attributes.term_life_plan.data.attributes.term_life_plan_translations.data[0].attributes
                .underwriting_text,

            // // insurer
            insurer_name_first:
              item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo,
            insurer_code:
              item.attributes.term_life_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,
            scenarioID: item.id,

            first_year_premium: fyp,
            product_promotion: promotion,
            promotion_prices: promotionPrices,
            promotion_last_call: promotion_last_call,

            discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
            discounted_twenty_year_avg_premium: discountedTwentyYearAvgPremium,
            decoder_cta_link: decoderCTALink,
            decoder_cta_text: decoderCTAText,
            shortcut: shortcut,
          };
        });
      }
      return null;
    },
    simpleCurrencies() {
      let currName;
      if (this.currencies) {
        return this.currencies.data.map((curr) => {
          if (this.currentLocale === 'zh-Hant-HK') {
            currName = curr.attributes.currency_translations.data[0].attributes.text;
          } else {
            currName = curr.attributes.currency_translations.data[0].attributes.localizations.data[0].attributes.text;
          }

          return {
            value: curr.id,
            text: currName,
          };
        });
      }
      return null;
    },
    filterTatgetPeriodValue() {
      return this.filter.targetPeriodValue.value;
    },
    slug() {
      return 'term-life'
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
  },

  watch: {
    filterTatgetPeriodValue: {
      handler(newVal) {
        setTimeout(() => {
          const options = [
            { value: 'score', text: this.$t('products.termLife.tl_10LifeRating') },
            {
              value: 'avg_premium',
              text: newVal + this.$t('products.termLife.tl_YearAveragePremium'),
            },
            { value: 'first_premium', text: this.$t('products.termLife.tl_firstYearPremium') },
          ];
          this.$_.set(this, 'sortingData.sortingOptions', options);

          const filterValueToFix = {
            filterValuePath: 'sortingData.sortValue',
            filterOptionsPath: 'sortingData.sortingOptions',
            queryKey: 'sort',
            defaultValue: 'score',
          };
          this.fixFilterValue(filterValueToFix);
        }, 700);
      },
    },
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.genderValue',
        filterOptionsPath: 'filter.genderOptions',
        queryKey: 'gender',
        defaultValue: '1',
      },
      {
        filterValuePath: 'filter.ageValue',
        filterOptionsPath: 'filter.ageOptions',
        queryKey: 'age',
        defaultValue: '35',
      },
      {
        filterValuePath: 'filter.targetPeriodValue',
        filterOptionsPath: 'filter.targetPeriodOptions',
        queryKey: 'target_period',
        defaultValue: '10',
      },
      {
        filterValuePath: 'filter.totalPremiumValue',
        filterOptionsPath: 'filter.totalPremiumOptions',
        queryKey: 'total_premium',
        defaultValue: '1000000',
      },
      {
        filterValuePath: 'filter.renewalTermValue',
        filterOptionsPath: 'filter.renewalTermOptions',
        queryKey: 'renewal_term',
        defaultValue: '-1',
      },
      {
        filterValuePath: 'filter.underwritingValue',
        filterOptionsPath: 'filter.underwritingOptions',
        queryKey: 'underwriting',
        defaultValue: '-1',
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingData.sortingOptions',
        queryKey: 'sort',
        defaultValue: 'score',
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'filter.advisorAssistanceValue',
        queryKey: 'advisorAssistance',
        defaultValue: false,
        ignoreFix: true,
        type: 'checkbox',
      },
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);
  },

  mounted() {
    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };

    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
  },

  methods: {
    getScore(filter, product) {
      if (filter.targetPeriodValue?.value === '10') {
        return product.ten_year_rating;
      } else if (filter.targetPeriodValue?.value === '20') {
        return product.twenty_year_rating;
      }
      return 0;
    },
    getAvgPremium(filter, product) {
      if (filter.targetPeriodValue?.value === '10') {
        return this.$formatPrice(product.ten_year_avg_premium);
      } else if (filter.targetPeriodValue?.value === '20') {
        return this.$formatPrice(product.twenty_year_avg_premium);
      }
      return 0;
    },

    getRenewal(label, renewalTerm) {
      if (renewalTerm === 1) {
        return this.$t('products.annualRenewal');
      }
      return label.replace('$num', renewalTerm);
    },

    getPremium(premium, startAge, renewalTerm, sumAssured) {
      const totalYear = 20;
      const result = new Array(20);
      const session = totalYear / renewalTerm;
      let lockedPremium = 0;

      for (let i = 0; i < session; i++) {
        // lock by the first year in the renewal_term

        lockedPremium = (premium.data.attributes['age_' + (parseInt(startAge) + i * renewalTerm)] * sumAssured / 1000).toFixed(2);
        for (let j = 0; j < renewalTerm; j++) {
          result[i * renewalTerm + j] = lockedPremium;
        }
      }
      return result;
    },

    getTooltipContentByKey(mKey) {
      return this.termLifeTooltips?.TermLife?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },
  },
  components: { QuickGuideWrapper }
};
